<template>
  <div class="inline-flex items-center h-6 rounded-full bg-gray-100 px-2.5 text-gray-600 dark:bg-white/5 dark:text-white/80">
    <span class="inline-flex h-2 w-2 mr-2 relative">
      <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-30" />
      <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500" />
    </span>
    <span class="leading-none text-xs">{{ $t('components.order.elements.barcode.ready') }}</span>
  </div>
</template>

<script setup lang="ts">
const { $api, $notification, $i18n } = useNuxtApp()

interface Props {
  order: any
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
})

const emit = defineEmits<{
  (e: 'update:loading', value: boolean): void
  (e: 'update:order', value: any): void
}>()

const code = ref('')
const reading = ref(false)
const timeoutId = ref<ReturnType<typeof setTimeout> | null>(null)

function handleKeyPress($event: KeyboardEvent) {
  const key = $event.key

  if (key === 'Enter') {
    if (code.value.length > 10) {
      handleBarcodeScan()
      code.value = ''
    }
  } else {
    code.value += key
  }

  if (timeoutId.value) {
    clearTimeout(timeoutId.value)
  }

  reading.value = true

  timeoutId.value = setTimeout(() => {
    code.value = ''
    reading.value = false
  }, 200)
}

async function handleBarcodeScan() {
  try {
    const c = code.value

    if (c.length >= 6) {
      emit('update:loading', true)

      const response = await $api.order.addProductWithBarcode(String(props.order.idOrder), c)
      const order = response.data

      emit('update:order', order)

      $notification.toast({
        title: $i18n.t('components.order.elements.barcode.success'),
        text: $i18n.t('components.order.elements.barcode.successInfo'),
        variant: 'success',
      })
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }

  emit('update:loading', false)
}

onMounted(() => {
  nextTick(() => {
    document.addEventListener('keypress', handleKeyPress)
  })
})

onBeforeUnmount(() => {
  document.removeEventListener('keypress', handleKeyPress)
  if (timeoutId.value) {
    clearTimeout(timeoutId.value)
  }
})
</script>
